import { Alert } from '@change/ds-core-ui/Alert';
import { Button } from '@change/ds-core-ui/Button';
import { Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/Modal';
import { Spinner } from '@change/ds-core-ui/Spinner';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { DecisionMakerCard } from '../DecisionMakerCard';
import { LegislativeBodyCard } from '../LegislativeBodyCard';

import { useViewAll } from './hooks/useViewAll';

export const ViewAll: React.FC<{ totalDmCount: number }> = ({ totalDmCount }) => {
	const {
		data: { dmsAndLBs, petitionAsk, loading, error },
		actions: { handleViewAllClick },
	} = useViewAll();

	const { translate } = useI18n();

	const renderModalBodyContent = () => {
		if (loading) {
			return (
				<div className="m-auto" data-testid="loader">
					<Spinner />
				</div>
			);
		}

		if (error) {
			return (
				<Alert className="my-4" variant="error">
					<Translate value="fe.errors.generic_try_again" />
				</Alert>
			);
		}

		return (
			<div className="flex flex-col gap-6">
				{dmsAndLBs.map((body) =>
					body.type === 'single' ? (
						<DecisionMakerCard key={body.displayedDMs[0].id} dm={body.displayedDMs[0]} />
					) : (
						<LegislativeBodyCard key={body.title} legislativeBody={body} />
					),
				)}
			</div>
		);
	};

	return (
		<Modal
			size="large"
			onClose={() => {}}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			trigger={
				<div className="w-full text-center">
					<Button data-qa="legislative-bodies-show-all" className="w-full" onClick={handleViewAllClick}>
						<TranslatePlural
							value="corgi.petition_gamma.decision_makers_v2.view_all.trigger"
							replacements={{ numberOfDms: totalDmCount }}
							count={totalDmCount}
						/>
					</Button>
				</div>
			}
			className="z-5000 lg:**:col-span-full!"
			data-qa="all-decision-makers-modal"
		>
			<ModalHeader title={translate('corgi.petition_gamma.decision_makers_v2.view_all.title')} subtitle={petitionAsk} />
			<ModalBody className="max-h-none!">{renderModalBodyContent()}</ModalBody>
		</Modal>
	);
};
